module.exports = __webpack_public_path__ + "static/media/banner-animation-mobile.19aaecb6.mp4";